import script from "./LuckyNumbersView.vue?vue&type=script&setup=true&lang=ts"
export * from "./LuckyNumbersView.vue?vue&type=script&setup=true&lang=ts"

import "./LuckyNumbersView.vue?vue&type=style&index=0&id=43e8a41c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43e8a41c"]])

export default __exports__